import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import * as Styles from './GoBackLink.styles';

type GoBackButtonProps = {
  onClick?: () => void;
  className?: string;
};

const GoBackButton = ({ onClick, ...props }: GoBackButtonProps): JSX.Element => {
  return (
    <Styles.Button data-testid="go-back-link" onClick={onClick} {...props}>
      <KeyboardArrowLeftIcon fontSize="inherit" />
      Back
    </Styles.Button>
  );
};

export default GoBackButton;
